export const commonStyles = {
  control: (base, state) => ({
    height: '48px',
    fontWeight: '400',
    backgroundColor: state.isDisabled ? '#ddd' : '#fff',
    color: '#3f4254',
    border: state.isFocused ? '1px solid rgb(56, 189, 248)' : '1px solid #a4a4a4',
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.18), inset 0 1px 2px rgba(255,255,255,0.25)',
    opacity: state.isDisabled ? '0.75' : '1',
    borderRadius: '2rem',
    fontSize: '1.125rem',
    padding: '0 1.42rem 0 3rem',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    pointerEvents: 'auto'
  }),
  valueContainer: (base) => ({
    ...base,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingRight: '0'
  }),
  container: (base) => ({
    ...base,
    width: '100%',
  }),
  input: (base) => ({
    ...base,
    paddingLeft: '0.5rem'
  }),
  placeholder: (base) => ({
    ...base,
    fontWeight: '400'
  }),
  dropdownIndicator: (base) => ({
    ...base,
    position: 'absolute',
    top: '15%',
    left: '0.75rem',
    color: 'rgb(56, 189, 248) !important',
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  singleValue: () => ({
    color: '#3f4254'
  }),
  menu: (base) => ({
    ...base,
    top: '86%',
    border: '1px solid rgb(56, 189, 248)',
    zIndex: 999
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: '200px',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'rgba(56, 189, 248, 0.45)'
      : state.isFocused
        ? 'rgba(56, 189, 248, 0.2)'
        : 'transparent',
    color: state.isSelected ? '#3a2600' : '#000',
    fontWeight: state.isSelected ? 500 : 400,
    cursor: 'pointer',
    fontSize: '1.125rem',
    textAlign: 'right',
  }),
};
export const filtersBar = {
  input: (base) => ({
    ...base,
    paddingLeft: '1rem',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: '23%',
    left: '2.25rem',
    borderLeft: '1px solid #6c6c6c',
    color: 'rgb(56, 189, 248)',
  }),
  menu: (base) => ({
    ...base,
    top: '86%',
    border: '1px solid rgb(56, 189, 248)',
    zIndex: 9999
  }),
};
export const createDocumentGridSelectStyles = {
  control: (base, state) => ({
    height: '48px',
    fontWeight: '400',
    backgroundColor: state.isDisabled ? '#ddd' : '#fff',
    color: '#3f4254',
    border: state.isFocused ? '1px solid rgb(56, 189, 248)' : '1px solid #a4a4a4',
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.18), inset 0 1px 2px rgba(255,255,255,0.25)',
    opacity: state.isDisabled ? '0.75' : '1',
    borderRadius: '2rem',
    fontSize: '1.125rem',
    padding: '0 1.42rem 0 3rem',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    pointerEvents: 'auto'
  }),
  valueContainer: (base) => ({
    ...base,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingRight: '0',
    position: 'relative'
  }),
  container: (base) => ({
    ...base,
    position: 'static',
  }),
  input: (base) => ({
    ...base,
    paddingLeft: '0.5rem'
  }),
  placeholder: (base) => ({
    ...base,
    fontWeight: '400',
  }),
  dropdownIndicator: () => ({
    position: 'absolute',
    top: '60%',
    left: '-2.4rem',
    color: 'rgb(56, 189, 248) !important',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#3f4254',
  }),
  menu: (base) => ({
    ...base,
    top: 'initial',
    position: 'absolute',
    width: '210px',
    zIndex: 999,
    border: '1px solid rgb(56, 189, 248)',
    marginTop: 0
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? 'rgba(56, 189, 248, 0.45)'
      : state.isFocused
        ? 'rgba(56, 189, 248, 0.2)'
        : 'transparent',
    color: state.isSelected ? '#3a2600' : '#000',
    fontWeight: state.isSelected ? 500 : 400,
    cursor: 'pointer',
    fontSize: '1.125rem',
    textAlign: 'right',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    position: 'relative',
    top: '-100%'
  }),
};
export const createDocumentGridReceiptSelectStyles = {
  singleValue: () => ({
    color: '#3f4254',
    position: 'absolute',
    right: 0
  }),
};
export const createDocumentGridReceiptOtherSelectStyles = {
  container: (base, state) => ({
    ...base,
    width: '210px',
    position: 'static',
    marginLeft: '1rem',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    pointerEvents: 'auto'
  }),
  singleValue: () => ({
    color: '#3f4254',
    position: 'absolute',
    right: 0
  }),
};